import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import axiosService from 'utils/axios';
import LoadingSpinner from 'components/Shared/LoadingSpinner/LoadingSpinner';
import SearchBar from 'components/SearchBar/SearchBar';
import CardsView from 'components/Shared/CardsView/CardsView';
import ActionButton from 'components/Shared/Buttons/ActionButton';
import NotifyCard from './NotifyCard';
import { notifyCardStyles } from './styles';
import AddOrEditNotify from './AddOrEditNotify';

export default function NotifiesList() {
  const [isLoading, setIsLoading] = useState(false);
  const [notifies, setNotifies] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [addNewNotifyModalOpen, setAddNewNotifyModalOpen] = useState(false);

  const getNotifies = useCallback(() => {
    setIsLoading(true);
    axiosService
      .get(`/entities/notify/?search=${searchText}`)
      .then(res => {
        setNotifies(res.data);
      })
      .finally(() => setIsLoading(false));
  }, [searchText]);

  const onNewNotifyModalClose = () => {
    getNotifies();
    setAddNewNotifyModalOpen(false);
  };

  useEffect(() => {
    // Fetch notifies on mount
    getNotifies();
  }, [getNotifies]);

  return (
    <>
      <SearchBar label="Search a notify..." setQuery={setSearchText} />
      <div style={notifyCardStyles.actionsContainer}>
        <ActionButton type="add" onClick={() => setAddNewNotifyModalOpen(true)}>
          Notify
        </ActionButton>
      </div>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          <CardsView
            data={notifies}
            emptyMessage="No notifies found."
            // @ts-ignore
            CardComponent={NotifyCard}
            onNotifyDelete={getNotifies}
            onNotifyUpdate={getNotifies}
          />
          <AddOrEditNotify
            onSave={onNewNotifyModalClose}
            modalTitle="Add new notify"
            isModalOpen={addNewNotifyModalOpen}
            setModalOpen={setAddNewNotifyModalOpen}
          />
        </>
      )}
    </>
  );
}
